
import { useState } from 'react';

export default function Home() {
  const [selectedWork, setSelectedWork] = useState(0);

  const works = [
    {
      title: "映画「夏の記憶」",
      role: "主演・田中健太郎役",
      year: "2023年",
      description: "青春の輝きと切なさを描いた感動作で、繊細な演技が高く評価された代表作。",
      image: "https://public.readdy.ai/ai/img_res/4e14eab2ef1debb3a525cf8900a26028.jpg"
    },
    {
      title: "ドラマ「都市の光」",
      role: "準主演・佐藤誠役",
      year: "2023年",
      description: "現代社会の複雑さを描いたヒューマンドラマで、多層的なキャラクターを見事に演び分けた。",
      image: "https://readdy.ai/api/search-image?query=Japanese%20businessman%20in%20modern%20office%20building%20at%20night%2C%20city%20lights%20in%20background%2C%20professional%20attire%2C%20confident%20expression%2C%20urban%20drama%20atmosphere%2C%20cinematic%20composition%2C%20high%20quality%20portrait&width=400&height=300&seq=work2&orientation=landscape"
    },
    {
      title: "舞台「風の詩」",
      role: "主演・山田太郎役",
      year: "2022年",
      description: "古典的な物語を現代的に解釈した舞台で、力強い存在感と豊かな表現力を披露。",
      image: "https://readdy.ai/api/search-image?query=Japanese%20actor%20on%20theater%20stage%20with%20dramatic%20lighting%2C%20traditional%20Japanese%20elements%20mixed%20with%20modern%20staging%2C%20powerful%20performance%20pose%2C%20theatrical%20atmosphere%2C%20spotlight%20effect%2C%20professional%20stage%20photography&width=400&height=300&seq=work3&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900" style={{fontFamily: '"Pacifico", serif'}}>
                高原知秀
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="#about" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  プロフィール
                </a>
                <a href="#works" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  ギャラリー
                </a>
                <a href="#contact" className="bg-gray-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-800 cursor-pointer whitespace-nowrap">
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* ヒーローセクション */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/2cb2cc74fe2fba73bf3bcb890f089d4e.png')`
        }}
      >
        <div className="text-center text-white z-10 max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            高原知秀
          </h1>
          <p className="text-xl md:text-2xl mb-8 font-light">
            俳優 / Actor
          </p>
          <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
            映画、ドラマ、舞台で活躍するフリーランス俳優。<br />
            豊かな表現力と確かな演技力で、あらゆるキャラクターに命を吹き込みます。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#works" 
              className="bg-white text-gray-900 px-8 py-3 rounded-md text-lg font-medium hover:bg-gray-100 transition duration-300 cursor-pointer whitespace-nowrap"
            >
              ギャラリーを見る
            </a>
            <a 
              href="#contact" 
              className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-medium hover:bg-white hover:text-gray-900 transition duration-300 cursor-pointer whitespace-nowrap"
            >
              キャスティング相談
            </a>
          </div>
        </div>
      </section>

      {/* プロフィールセクション */}
      <section id="about" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">プロフィール</h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  福岡県出身の俳優。1993年頃に俳優デビュー。
                  1990年代から数々の東映製作特撮作品にゲスト出演し、経験を積む。
                </p>
                <p>
                  2003年、東宝製作の特撮ドラマ『超星神グランセイザー』で松坂直人 / セイザータウロン役を演び、
                  注目を集める。その後も『仮面ライダーキバ』のルーク役など、
                  特撮作品を中心に幅広く活躍。
                </p>
                <p>
                  現在は劇団野良犬弾の座長としても活動。
                  テレビドラマ、映画、舞台、Vシネマなど多岐にわたるジャンルで
                  確かな演技力を発揮し続けている実力派俳優。
                </p>
              </div>
              <div className="mt-8 grid grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">birthday</h3>
                  <p className="text-gray-700">1973年3月22日</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">出身地</h3>
                  <p className="text-gray-700">福岡県</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">身長</h3>
                  <p className="text-gray-700">178cm</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">血液型</h3>
                  <p className="text-gray-700">A型</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">特技</h3>
                  <p className="text-gray-700">アクション全般</p>
                </div>
              </div>
            </div>
            <div className="lg:pl-12">
              <img 
                src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/ad44e3b0d36bb4a855ad48303ba36697.jpeg"
                alt="高原知秀プロフィール写真"
                className="w-full rounded-lg shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 出演作品セクション */}
      <section id="works" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">ギャラリー</h2>
          </div>
          
          {/* メインフィーチャー画像 */}
          <div className="mb-16">
            <div className="relative group overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/43c1856f496a02675d66d211fa33c3eb.jfif"
                alt="高原知秀 メインビジュアル"
                className="w-full h-[600px] object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
          </div>

          {/* アートギャラリーグリッド */}
          <div className="grid grid-cols-12 gap-6 mb-16">
            {/* 大きな縦長画像 */}
            <div className="col-span-12 md:col-span-5">
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/61b17a1c0ebfb09baf8b94481b907011.jfif"
                  alt="舞台作品"
                  className="w-full h-[700px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>

            {/* 右側の複数画像 */}
            <div className="col-span-12 md:col-span-7 grid grid-cols-2 gap-6">
              {/* 横長画像 */}
              <div className="col-span-2">
                <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500">
                  <img 
                    src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/c9632b2070add13f9a8f5e148bfe46bf.jfif"
                    alt="ドラ画作品"
                    className="w-full h-[350px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
              </div>

              {/* 正方形画像2つ */}
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/08082e7000e7938497a89e522b6d78ec.jfif"
                  alt="特撮作品"
                  className="w-full h-[340px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>

              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/bdc2c1c6bc9e1aa4fd688b37ff2c7b32.png"
                  alt="映画作品"
                  className="w-full h-[340px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>
          </div>

          {/* アーティスティックコラージュ */}
          <div className="mt-16">
            <div className="grid grid-cols-4 gap-4">
              <div className="col-span-2 row-span-2">
                <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 h-full">
                  <img 
                    src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/dab852d8c2e8571d2c9a53d7637f8072.png"
                    alt="アーティスティックポートレート"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-black/30"></div>
                </div>
              </div>
              
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/6e7b84e8fa5473a653149742e1e91ba3.png"
                  alt="撮影風景"
                  className="w-full h-[300px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/b49d2ed2c8952c708a0dae457b13a3f6.jfif"
                  alt="衣装合わせ"
                  className="w-full h-[300px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/7c42199ef9e112598ce2b7f4c5323eed.png"
                  alt="台本読み"
                  className="w-full h-[300px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              
              <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-500">
                <img 
                  src="https://static.readdy.ai/image/02236bff9fadd4480e00e7dd82f3e2dc/a43b8bb9f2acb98c9df1dfd12dec4216.png"
                  alt="リハーサル風景"
                  className="w-full h-[300px] object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* お問い合わせセクション */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">お問い合わせ</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              キャスティングのご相談、出演依頼など、お気軽にお声がけください
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-900 rounded-full">
                    <i className="ri-mail-line text-white"></i>
                  </div>
                  <h4 className="ml-4 text-xl font-semibold text-gray-900">キャスティング依頼、ご相談等</h4>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  映画、ドラマ、舞台などの出演依頼については、担当者に直接ご連絡ください。
                  詳細な打ち合わせの上で、最適なプランをご提案いたします。
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-pink-500 rounded-full">
                    <i className="ri-article-line text-white"></i>
                  </div>
                  <h4 className="ml-4 text-xl font-semibold text-gray-900">アメブロ</h4>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  高原知秀さんのブログ
                </p>
                <a 
                  href="https://ameblo.jp/hide22031973/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-pink-500 text-white px-4 py-2 rounded-md hover:bg-pink-600 transition duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-external-link-line mr-2"></i>
                  ブログを見る
                </a>
              </div>
              
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-8">お問い合わせフォーム</h3>
              <form 
                className="space-y-6" 
                data-readdy-form
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.target as HTMLFormElement);
                  const data = new URLSearchParams();
                  formData.forEach((value, key) => {
                    data.append(key, value.toString());
                  });
                  
                  fetch('https://readdy.ai/api/form/d3lejpc45u2jkf5ftmr0', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data
                  }).then(() => {
                    alert('お問い合わせを送信いたしました。ありがとうございます。');
                    (e.target as HTMLFormElement).reset();
                  }).catch(() => {
                    alert('送信に失敗しました。もう一度お試しください。');
                  });
                }}
              >
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">お名前</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900"
                    placeholder="山田太郎"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">メールアドレス</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900"
                    placeholder="example@domain.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">会社名（任意）</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900"
                    placeholder="株式会社サンプル"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">お問い合わせ内容</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900"
                    placeholder="ご相談内容を具体的にご記入ください（500文字以内）"
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-gray-900 text-white py-3 px-6 rounded-md hover:bg-gray-800 transition duration-300 font-medium whitespace-nowrap"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{fontFamily: '"Pacifico", serif'}}>高原知秀</h3>
              <p className="text-gray-300 mb-4">
                映画、ドラマ、舞台で活躍するフリーランス俳優。<br />
                あらゆるキャラクターに命を吹き込みます。
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-twitter-line text-2xl"></i>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-instagram-line text-2xl"></i>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-youtube-line text-2xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">ナビゲーション</h4>
              <ul className="space-y-2">
                <li><a href="#about" className="text-gray-300 hover:text-white">プロフィール</a></li>
                <li><a href="#works" className="text-gray-300 hover:text-white">ギャラリー</a></li>
                <li><a href="#contact" className="text-gray-300 hover:text-white">お問い合わせ</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <div className="space-y-2 text-gray-300">
                <p><i className="ri-mail-line mr-2"></i>hide22031973@gmail.com</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2023 高原知秀 Actor Portfolio. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
